import api from '@/com/system/api'

class ServiceLogin {
  
  async registerUser (uObj) {
    try {
      let res = await api.postAdmin('/v1/sec/signup', uObj)
      return res
    } catch {
      return false
    }
  }
  
  async confirmUser (uObj) {
    try {
      let res =  await api.postAdmin('/v1/sec/confirm', uObj)
      return res
    } catch {
      return false
    }
  }

  async resendConfirm (uObj) {
    try {
      let res =  await api.postAdmin('/v1/sec/resend', uObj)
      return res
    } catch {
      return false
    }
  }

  async signinUser (uObj) {
    try {
      let res =  await api.post('/v1/sec/signin', uObj)
      if (res.status === 200) {
        return res
      } else {
        console.log('what')
        return false
      }
    } catch {
      console.log('failure')
    }
  }

  async getUserProfile (short) {
    try {
      const res =  await api.getAdmin(`/v1/profile/${short}/profile`)
      if (res.status === 200) {
        return res.data
      } else {
        return false
      }
    } catch {
      console.log('failure')
    }
  }

  async verifyUser () {
    let res = await api.getAdmin('/v1/sec/verify')
    if (res.code === 'ERR_BAD_REQUEST') {
      return false
    } else {
      return true
    }
  }

  async saveProfile (rltrid, profile) {
    try {
      const res = await api.postAdmin(`/v1/profile/${rltrid}/profile`, profile)
      return res
    } catch (err) {
      console.log(err)
      return false
    }
  }

  async changePassword (_user) {
    try {
      const res = await api.post('/v1/sec/new-password', _user);
      return res;
    } catch (err) {
      console.log(err)
      return false
    }
  }

  // Exchanges the httpOnly refresh cookie for a new access token. No body —
  // the browser attaches the cookie itself. A 401 here just means there's no
  // valid cookie, i.e. a normal logged-out visitor.
  async refresh () {
    try {
      const res = await api.get('/v1/sec/refresh')
      return res
    } catch {
      return false
    }
  }

  // Required to actually log out — JS cannot clear an httpOnly cookie, so
  // only the server can end the session.
  async logout () {
    try {
      const res = await api.post('/v1/sec/logout')
      return res
    } catch {
      return false
    }
  }

}

export default new ServiceLogin()